import compose from 'ramda/es/compose';

type ThumbType =
  | 'hqdefault'
  | 'default'
  | 'mqdefault'
  | 'sddefault'
  | 'maxresdefault';

const getThumbUrl = (type: ThumbType) => (id: string): string =>
  `https://img.youtube.com/vi/${id}/${type}.jpg`;

export const getYouTubeId = (url: string): string => {
  const match = url.match(
    /(?:youtu\.be\/|youtube\.com\/(?:embed\/|v\/|watch\?v=|watch\?.+&v=))((\w|-){11})|youtube\.com\/playlist\?list=/,
  );

  return (match && match[1]) || '';
};

export const getHdThumb = getThumbUrl('hqdefault');
export const getYoutubeThumbFromUrl = compose(
  getHdThumb,
  getYouTubeId,
);
